import React, { useState } from 'react'
import Page from 'src/components/Page'
import {
  makeStyles,
  Grid,
  Button,
  Dialog,
  IconButton,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core'
import {
  Link,
  useNavigate,
} from 'react-router-dom'
import DeleteIcon from 'src/icons/DeleteIcon'
import EditIcon from 'src/icons/EditIcon'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment-jalaali'
import MUIDataTable from 'mui-datatables'
import { ThemeProvider } from '@material-ui/core/styles'
import muiDefaultOptions from '../../constants/muiTableOptions'
import { getMuiTheme } from '../../utils/TableStyle'
import { selectUserInfo } from '../../app/slices/userSlice'
import { getAllPackages, selectorAllPackage } from '../../app/slices/packageSlice'

const useStyle = makeStyles((theme) => ({
  root: {
  },
  title: {
    marginBottom: 15,
  },
  icon: {
    marginRight: 10,
  },
  valueCell: {
    color: '#000',
    [theme.breakpoints.down('sm')]: {
      textAlign: 'right',
    },
  },
  icons: {
    color: '#b2b6c0',
    transition: '0.2s',
    '&:hover': {
      color: '#f39994',
    },
  },
}))

export const PackagesList = () => {
  const classes = useStyle()
  const dispatch = useDispatch()
  const { role } = useSelector(selectUserInfo)
  const allPackage = useSelector(selectorAllPackage)
  const navigate = useNavigate()

  const getPackage = allPackage?.filter((item) => item.id === 2)
  console.log(getPackage)
  console.log(allPackage)

  const [packageIdToDelete, sePackageIdToDelete] = useState(null)

  React.useEffect(() => {
    if ([2, 3].includes(role?.roleId)) {
      dispatch(getAllPackages())
    }
  }, [])

  const COLUMNS = [
    {
      name: 'category',
      label: 'ردیف',
      options: {
        customBodyRender: (value) => (<p className={classes.valueCell}>{value.ageCategoryId}</p>),
      },
    },
    {
      name: 'id',
      label: 'نام بسته',
      options: {
        customBodyRender(value, data) {
          console.log(data.rowData[0].name)
          return (
            <Link to={`./${value}`}>
              <p
                style={{
                  whiteSpace: 'nowrap',
                  //  marginRight: '-100px' ,
                  float: window.outerWidth < 960 ? 'left' : '',
                }}
                className={classes.valueCell}
              >

                {data?.rowData[0]?.name}
              </p>
            </Link>
          )
        },
      },
    },
    {
      name: 'createDate',
      label: 'تاریخ ایجاد',
      options: {
        customBodyRender: (value) => (
          <p className={classes.valueCell}>{value ? moment(value)?.format('jYYYY/jMM/jDD') : '--'}</p>
        ),
      },
    },
    {
      name: 'category',
      label: 'رده سنی',
      options: {
        customBodyRender: (value) => (
          <p className={classes.valueCell}>{`${value?.toYear} - ${value?.fromYear}`}</p>
        ),
      },
    },
    {
      name: 'id',
      label: 'مدیریت',
      options: {
        sort: false,
        filter: false,
        customBodyRender: (value, { rowData }) => {
          return (
            <div>
              <Link to={`./edit/${value}`}>

                <IconButton>
                  <EditIcon className={classes.icons} />
                </IconButton>

              </Link>
              <IconButton onClick={() => {
                sePackageIdToDelete(rowData[0])
              }}
              >
                <DeleteIcon
                  className={classes.icons}
                />

              </IconButton>
            </div>
          )
        },
      },
    },
  ]

  const handleClose = (shouldDelete) => {
    if (shouldDelete) {
      // dispatch(deleteUser(
      // userIdToDelete, () => setRefresh(!refresh),
      // ))
    }
    sePackageIdToDelete(null)
  }

  return (
    <Page
      className={classes.root}
      title="فهرست پکیج ها"
    >
      <Grid className={classes.root}>
        <ThemeProvider theme={getMuiTheme}>
          <MUIDataTable
            data={allPackage}
            columns={COLUMNS}
            options={{
              ...muiDefaultOptions,
              serverSide: true,
              filter: true,
              print: false,
              download: false,
              search: true,
              rowHover: true,
              // responsive: 'scroll',
              // selectableRowsHeader: true,
              // expandableRows: true,
              expandableRowsOnClick: true,
              onRowClick: (rowData, rowMeta) => {
                console.log(rowData)
                console.log(rowMeta)
                const packageId = rowMeta?.rowIndex + 1
                navigate(`/app/exams/packages/${packageId}`)
              },
              selectableRows: 'none',
              searchable: true,
              sort: true,
              pagination: true,
              viewColumns: true,
            }}
          />
        </ThemeProvider>
      </Grid>
      <Dialog
        className={classes.deleteDialog}
        open={packageIdToDelete}
        onClose={() => handleClose(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle className={classes.dialogHeader} id="alert-dialog-title">حذف کاربر</DialogTitle>
        <DialogContent>
          <DialogContentText className={classes.dialogDesc} id="alert-dialog-description">
            آیا از حذف این کاربر اطمینان دارید؟
          </DialogContentText>
        </DialogContent>
        <DialogActions className={classes.dialogButtons}>
          <Button onClick={() => handleClose(false)} className={classes.cancelModalBtn}>
            لغو
          </Button>
          <Button onClick={() => handleClose(true)} className={classes.deleteModalBtn} autoFocus>
            حذف
          </Button>
        </DialogActions>
      </Dialog>
    </Page>

  )
}

export default PackagesList
